module.exports = __webpack_public_path__ + "img/ad-4.4d40a711.png";